<template>
    <div class="container">
        <div class="card">
            <div class="card-header">
                <h5 class="mb-0">
                    <a class="button" v-b-toggle="id">{{title}}</a>
                </h5>
            </div>
            <b-collapse v-model="toggle" :id="id">
                <slot></slot>
            </b-collapse>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'CollapsableComponent',
        props: ['id', 'title', 'visible'],
        data() {
            return {
                toggle: this.$props.visible
            }
        }
    }
</script>

<style scoped>
    .container {
        margin-top: 20px;
        margin-bottom: 20px;
    }

    .card {
        border-radius: 2px;
    }

    .button {
        text-decoration: none;
        color: #1A1A1A;
        font-weight: normal;
        cursor: pointer;
    }
</style>